module.exports = __webpack_public_path__ + "img/logo_blanco.6e2b4fc0.png";